import { Input, Select, DatePicker, Slider, Switch } from '@Sage/hoi-poi-ui';
import Products from './customFilters/Products';

// quantity type translates into an integer field type in getFieldProps method,
// but we need to inform that quantity is an inputField
export const inputFields = ['text', 'integer', 'decimal', 'currency', 'percent', 'quantity'];

export const rangeFields = {
    date: DatePicker,
    integer: Input,
    decimal: Input,
    currency: Input,
    percent: Input,
};

export const defaultPlaceholders = {
    integer: '0',
    decimal: '0.00',
    currency: '0.00',
    percent: '0',
};

export const defaultValues = {
    probability: null,
    text: '',
    integer: '',
    decimal: '',
    currency: '',
    date: '',
    range: [],
    singleValueList: null,
    multipleValueList: [],
    relatedValueList: null,
    switch: false,
};

export const fieldsComponent = {
    bool: Select,
    switch: Switch,
    probability: Slider,
    singleValueList: Select,
    multipleValueList: Select,
    relatedValueList: Select,
    date: DatePicker,
    singleDate: DatePicker,
    text: Input,
    integer: Input,
    decimal: Input,
    currency: Input,
    percent: Input,
};

export const customFieldsComponent = {
    Products,
};
